export default "__VITE_ASSET__276061ce__"